import { render, staticRenderFns } from "./TaskBar.vue?vue&type=template&id=17726c09&"
import script from "./TaskBar.vue?vue&type=script&lang=js&"
export * from "./TaskBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports